const ErrorMsg = () => {
  return (
    <div className="text-center selection pt-7">
      <h1 className="text-5xl">Oops!</h1>
      <div>Something went wrong</div>
    </div>
  );
};

export default ErrorMsg;
